import _sfc_main from "./GenericDropdown2.mjs";
/* empty css                  */
import _export_sfc from "../../../_virtual/_plugin-vue_export-helper.mjs";
const GenericDropdown = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-b13f3c79"]]);
export {
  GenericDropdown as default
};
//# sourceMappingURL=GenericDropdown.mjs.map
